var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAllTech(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46471 7.90067C4.46471 7.90067 3.90196 8.62069 3.11224 8.99558C2.32252 9.37046 1.53364 9.15284 1.48179 8.47193C1.42994 7.79102 2.50188 7.31327 3.51348 7.55895C4.52507 7.80462 6.24478 8.80346 7.0209 9.17409C7.79702 9.54473 8.87152 9.7292 9.7641 8.83406C10.6567 7.93893 11.5204 7.25206 11.5204 7.25206",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71582 7.92363L4.58993 5.33514C5.34055 5.02401 6.51791 5.27053 7.81258 5.76018C9.10725 6.24982 11.4875 7.77911 14.3089 7.36513C14.3089 7.36513 14.6991 5.26968 13.7521 3.2907C12.902 1.50554 10.7768 0.675859 8.51304 1.1162C4.65879 1.86682 4.58993 5.33344 4.58993 5.33344",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19509 8.23986C5.19509 8.23986 3.84092 13.2341 6.96241 14.2822C8.70167 14.8662 10.3942 13.7076 11.427 12.7011",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1052 10.5784C12.9145 12.4701 13.0204 14.38 13.4189 16.2391C13.4189 16.2391 9.67855 18.5862 6.54346 16.3598C6.54346 16.3598 7.08496 16.0011 6.96254 14.2822",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75488 17.317C9.75488 17.317 11.1261 18.1943 11.0504 20.5286C11.0504 20.5286 13.4374 19.9004 14.7057 18.0923C15.4946 16.9668 13.4187 16.2391 13.4187 16.2391",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5433 16.3598C6.5433 16.3598 4.8525 16.455 5.02166 17.6145C5.22738 19.018 7.05675 20.2498 7.05675 20.2498C6.71672 18.3039 8.42708 17.1895 8.42708 17.1895",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87891 17.6757L2.57945 18.9449C2.09757 19.2349 1.69889 19.6446 1.42213 20.1342C1.14538 20.6238 0.999956 21.1767 1 21.7391V25H18.8882V21.7042C18.888 21.1508 18.747 20.6065 18.4784 20.1226C18.2098 19.6387 17.8225 19.231 17.353 18.9381L15.0059 17.4709",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8704 10.195C13.4042 10.3863 14.0265 10.0097 14.262 9.35346C14.4974 8.6972 14.256 8.01034 13.723 7.81907C13.3898 7.70006 13.0209 7.80207 12.7344 8.05624",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96445 21.2002C9.20154 21.2002 9.39374 21.008 9.39374 20.7709C9.39374 20.5338 9.20154 20.3416 8.96445 20.3416C8.72736 20.3416 8.53516 20.5338 8.53516 20.7709C8.53516 21.008 8.72736 21.2002 8.96445 21.2002Z",
    fill: "#003A5E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96445 23.5158C9.20154 23.5158 9.39374 23.3236 9.39374 23.0865C9.39374 22.8494 9.20154 22.6572 8.96445 22.6572C8.72736 22.6572 8.53516 22.8494 8.53516 23.0865C8.53516 23.3236 8.72736 23.5158 8.96445 23.5158Z",
    fill: "#003A5E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0813 7.90067C26.0813 7.90067 26.644 8.62069 27.4329 8.99557C28.2218 9.37046 29.0124 9.15284 29.0642 8.47193C29.1161 7.79102 28.0441 7.31327 27.0325 7.55894C26.0209 7.80462 24.3012 8.80346 23.5251 9.17409C22.749 9.54473 21.6745 9.72919 20.7811 8.83406C19.8876 7.93893 19.0273 7.24612 19.0273 7.24612",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8311 7.92363L25.9578 5.33514C25.2072 5.02401 24.0299 5.27053 22.7352 5.76018C21.4405 6.24982 19.0603 7.77911 16.2389 7.36513C16.2389 7.36513 15.8487 5.26968 16.7948 3.2907C17.6492 1.50554 19.7701 0.675859 22.0347 1.1162C25.889 1.86682 25.9578 5.33344 25.9578 5.33344",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.353 8.23986C25.353 8.23986 26.7072 13.2341 23.5857 14.2822C21.8464 14.8662 20.1539 13.7076 19.1211 12.7011",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4426 10.5784C17.6328 12.4701 17.527 14.38 17.1289 16.2391C17.1289 16.2391 20.8693 18.5862 24.0043 16.3598C24.0043 16.3598 23.4628 16.0011 23.5853 14.2822",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0049 16.3598C24.0049 16.3598 25.6957 16.455 25.5257 17.6145C25.3208 19.018 23.4914 20.2498 23.4914 20.2498C23.8315 18.3039 22.1211 17.1895 22.1211 17.1895",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6694 17.6757L27.9647 18.9449C28.4465 19.2349 28.8452 19.6446 29.122 20.1342C29.3987 20.6238 29.5441 21.1767 29.5441 21.7391V25H17.8887",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6763 10.195C17.1433 10.3863 16.521 10.0097 16.2855 9.35346C16.0501 8.6972 16.2915 8.01034 16.8245 7.81907C17.1577 7.70006 17.5258 7.80207 17.8131 8.05624",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5836 21.2002C21.8207 21.2002 22.0129 21.008 22.0129 20.7709C22.0129 20.5338 21.8207 20.3416 21.5836 20.3416C21.3465 20.3416 21.1543 20.5338 21.1543 20.7709C21.1543 21.008 21.3465 21.2002 21.5836 21.2002Z",
    fill: "#003A5E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5836 23.5158C22.8207 23.5158 23.0129 23.3236 23.0129 23.0865C23.0129 22.8494 22.8207 22.6572 22.5836 22.6572C22.3465 22.6572 22.1543 22.8494 22.1543 23.0865C22.1543 23.3236 22.3465 23.5158 22.5836 23.5158Z",
    fill: "#003A5E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0039 16.9039L15.2188 17.4709",
    stroke: "#003A5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAllTech);
export default __webpack_public_path__ + "static/media/ic-all-tech.76ba10c9.svg";
export { ForwardRef as ReactComponent };